import _Number$MAX_SAFE_INTEGER from 'babel-runtime/core-js/number/max-safe-integer';

import { groupItemMixin, jsonGroupItemMixin } from '@/views/creative/mixin/index.js';
import { isInteger, isDecimal } from '@/utils/number.js';

export default {
  mixins: [groupItemMixin, jsonGroupItemMixin],

  data: function data() {
    return {
      formConfig: {
        inline: true
      },
      isAllowConfig: 0,
      formValue: {
        customInput: '',
        unlimitedTime: 0
      }
    };
  },


  computed: {
    inputTitle: function inputTitle() {
      if (this.isPlayAgain) {
        return this.$t('playTurbo.gamePlay.playAgain.inputTitle');
      }
      if (this.isAutoEndTime) {
        return this.$t('playTurbo.gamePlay.autoEndTime.inputTitle');
      }
      return '';
    },
    radioOptions: function radioOptions() {
      var options = [];
      if (this.isPlayAgain) {
        options = this.$t('playTurbo.gamePlay.playAgain.options');
      }
      if (this.isAutoEndTime) {
        options = this.$t('playTurbo.gamePlay.autoEndTime.options');
      }
      options = options.map(function (item, index) {
        return {
          value: index,
          label: item
        };
      });
      return options;
    },
    radioTitle: function radioTitle() {
      if (this.isPlayAgain) {
        return this.$t('playTurbo.gamePlay.playAgain.radioTitle');
      }
      if (this.isAutoEndTime) {
        return this.$t('playTurbo.gamePlay.autoEndTime.radioTitle');
      }
      return '';
    },
    unit: function unit() {
      if (this.isPlayAgain) {
        return this.$t('playTurbo.gamePlay.playAgain.unit');
      }
      if (this.isAutoEndTime) {
        return 's';
      }
      return '';
    },
    confOptions: function confOptions() {
      var optionsMap = {
        playAgain: [{
          value: 1, // 1 选中无限试玩
          label: this.$t('playTurbo.gamePlay.playAgain.unlimited')
        }]
      };
      return optionsMap[this.category.prefix] || [];
    },
    isAutoEndTime: function isAutoEndTime() {
      return this.category.prefix === 'autoEndTime';
    },
    isPlayAgain: function isPlayAgain() {
      return this.category.prefix === 'playAgain';
    },
    unlimitedTimeVisible: function unlimitedTimeVisible() {
      return this.category.prefix === 'playAgain';
    },
    formItemList: function formItemList() {
      return {
        customInput: {
          prop: 'customInput',
          style: 'width: 120px;margin-right: 20px;',
          rules: [{
            validator: this.validateNumber,
            trigger: 'blur'
          }],
          params: {
            clearable: true,
            controlsPosition: 'right',
            // placeholder:
            //   this.$t(
            //     'playTurbo.creative.optionalGroupItem.customInput.placeholder'
            //   ),
            title: this.$t('playTurbo.creative.optionalGroupItem.customInput.placeholder'),
            disabled: this.isAllowConfig === 0 // 选择 no 的时候 disabled 输入框
          }
        },
        unlimitedTime: {
          visible: this.unlimitedTimeVisible,
          prop: 'unlimitedTime',
          params: {
            disabled: this.isAllowConfig === 0,
            options: this.confOptions
          }
        }
      };
    },
    hasPresetConf: function hasPresetConf() {
      return typeof this.presetConf !== 'undefined';
    },
    hasError: function hasError() {
      // autoEndTime 必须大于 0
      if (this.isAutoEndTime) return this.presetConf < 0;
      // playAgain 必须大于 -1
      if (this.isPlayAgain) return this.presetConf < -1;
      return true;
    }
  },

  mounted: function mounted() {
    var _this = this;

    if (this.hasPresetConf) {
      this.$nextTick(function () {
        _this.$refs.form && _this.$refs.form.validate && _this.$emit('add-validator', _this.$refs.form.validate);
      });

      this.isAllowConfig = this.cookIsAllowConfig();
      this.formValue = this.cookFormValue();
    }
  },


  methods: {
    // eslint-disable-next-line consistent-return
    cookIsAllowConfig: function cookIsAllowConfig() {
      if (this.isAutoEndTime) {
        // 大于 0 需要配置
        if (this.presetConf > 0) return 1;
        // 其他不需要配置
        return 0;
      }
      if (this.isPlayAgain) {
        // 0 不需要配置
        if (this.presetConf === 0) return 0;
        // 其他允许配置
        return 1;
      }
    },
    cookFormValue: function cookFormValue() {
      var formValue = {};

      if (this.presetConf >= 1) {
        formValue.customInput = this.presetConf;
      }
      if (this.isPlayAgain) {
        formValue.unlimitedTime = this.presetConf === -1 ? 1 : 0;
      }

      return formValue;
    },
    handleUnlimitedTimeRadioChange: function handleUnlimitedTimeRadioChange(val) {
      var _this2 = this;

      if (val === 1) {
        this.formValue.customInput = '';
        this.$emit('update', -1);
        this.$nextTick(function () {
          return _this2.$refs.form.validate();
        });
      }
    },
    handleAllowConfigRadioChange: function handleAllowConfigRadioChange(val) {
      if (val === 0) {
        this.formValue = {
          customInput: '',
          unlimitedTime: 0
        };
      }
      this.$emit('update', val);
      this.$refs.form.clearValidate();
    },
    handleBlur: function handleBlur() {
      var count = this.formValue.customInput;
      // 值不为空，去掉无时限按钮选择状态
      if (count !== '') this.formValue.unlimitedTime = 0;
      // 输入大于 0 的数字才更新
      if (Number(count) > 0) {
        this.$emit('update', count);
      }
    },
    validateNumber: function validateNumber(rule, value, callback) {
      // 选择了 no，不需要校验
      if (this.isAllowConfig === 0) {
        callback();
        return;
      }

      // 重玩次数选择了无限试玩，不需要校验
      if (this.isPlayAgain && this.presetConf === -1) {
        callback();
        return;
      }

      // 输入框为空但是选择了永远则认为没有错误
      if (value === '' && this.unlimitedTime) {
        callback();
        return;
      }

      if (isDecimal(value)) {
        callback(new Error(this.$t('playTurbo.creative.optionalGroupItem.validate.warning')));
        return;
      }

      if (isInteger(value)) {
        if (value > _Number$MAX_SAFE_INTEGER) {
          callback(new Error('' + value + this.$t('playTurbo.creative.optionalGroupItem.validate.warning1')));
          return;
        }

        if (value <= 0) {
          callback(new Error(this.$t('playTurbo.creative.optionalGroupItem.validate.warning2')));
          return;
        }

        callback();
        return;
      }

      callback(new Error(this.$t('playTurbo.creative.optionalGroupItem.validate.warning3')));
    }
  }
};